import { lazy } from "react";

export const GiftCertificateAsync = lazy(() => import("./GiftCertificate"));
